import { IChainable } from "./chainable.interface";
import { NullComponent } from "./null-component";
import { IProcessable } from "./processable.interface";

export class BaseChainableComponent<OutputType> implements IChainable<OutputType> {

	private _next: IProcessable<OutputType> = new NullComponent();
	protected get logger() {
		return console;
	}

	protected get next() { return this._next; }

	public connectTo(next: IProcessable<OutputType>) {

		this._next = next;
	}
}
